import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";

const THEME_KEY = "user_setting_theme"; // localStorage only (no Firebase persistence yet)
const DEFAULT_THEME = "dark";

const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

const readTheme = () => {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return v === "light" || v === "dark" ? v : DEFAULT_THEME;
  } catch (e) {
    return DEFAULT_THEME;
  }
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(readTheme);

  // Reflect the theme on <html> so the CSS variables in index.css apply.
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  const setTheme = useCallback((next) => {
    setThemeState(next);
    try {
      localStorage.setItem(THEME_KEY, next);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const toggleTheme = useCallback(
    () => setTheme(theme === "dark" ? "light" : "dark"),
    [theme, setTheme]
  );

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
